module.exports = {
          srcSet: __webpack_public_path__ + "99e5570855c7c3ceac99919edcdac185-17.png"+" 17w",
          images:[ {path: __webpack_public_path__ + "99e5570855c7c3ceac99919edcdac185-17.png",width: 17,height: 16}],
          src: __webpack_public_path__ + "99e5570855c7c3ceac99919edcdac185-17.png",
          toString:function(){return __webpack_public_path__ + "99e5570855c7c3ceac99919edcdac185-17.png"},
          
          width: 17,
          height: 16
        }